import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { DemoRequestsService } from './requestsApi';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import { IDemoRequestsListState } from '../../../../interfaces/demo-requests/IRequestList';
import { PaginatedRequests } from '../../../../interfaces/demo-requests/paginatedStore.type';

const initialState: IDemoRequestsListState = {
    requestsAreLoading: false,
    requestIsLoading: false,
    requestStatus: 'default',
    message: '',
};

export const tryToFetchDemoRequests = createAsyncThunk<PaginatedRequests, IPaginationPayload>(
    'demoRequests/tryToFetchDemoRequests',
    async ({ pageNumber, pageSize, filters, data }) => {
        const result = await DemoRequestsService.tryToFetchDemoRequests(
            pageNumber,
            pageSize,
            data,
            filters,
        );
        return result?.data;
    },
);

export const tryToEditDemoRequestStatus = createAsyncThunk<any, any>(
    'demoRequests/tryToEditDemoRequestStatus',
    async (data, { rejectWithValue }) => {
        try {
            const result = await DemoRequestsService.tryToEditDemoRequestStatus(data);
            return result?.data?.data;
        } catch (error) {
            const err: any = error as AxiosError;
            return rejectWithValue(err?.response?.data?.message);
        }
    },
);

export const tryToInviteNewMember = createAsyncThunk<any, any>(
    'demoRequests/tryToInviteNewMember',
    async (data, { rejectWithValue }) => {
        try {
            const result = await DemoRequestsService.tryToInviteNewMember(data);
            return result?.data?.data;
        } catch (error) {
            const err: any = error as AxiosError;
            return rejectWithValue(err?.response?.data?.message);
        }
    },
);

export const demoRequestsSlice = createSlice({
    name: 'demoRequests',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // tryToFetchDemoRequests
            .addCase(tryToFetchDemoRequests.pending, (state) => {
                state.requestsAreLoading = true;
            })
            .addCase(tryToFetchDemoRequests.rejected, (state) => {
                state.requestsAreLoading = false;
            })
            .addCase(tryToFetchDemoRequests.fulfilled, (state, action) => {
                state.requestsAreLoading = false;
                state.requests = action.payload;
            })

            // tryToEditDemoRequestStatus
            .addCase(tryToEditDemoRequestStatus.pending, (state) => {
                state.requestIsLoading = true;
            })
            .addCase(tryToEditDemoRequestStatus.rejected, (state) => {
                state.requestIsLoading = false;
            })
            .addCase(tryToEditDemoRequestStatus.fulfilled, (state, action) => {
                state.requestIsLoading = false;
                state.requestStatus = 'success';
                if (state.requests?.data.elements)
                    state.requests.data.elements =
                        { ...state }.requests?.data.elements.map((item) => {
                            if (item?._id === action.meta?.arg?.id) {
                                return {
                                    ...item,
                                    status: action?.meta?.arg?.status
                                };
                            } else {
                                return item;
                            }
                        }) || [];
            })

    },
});

export default demoRequestsSlice.reducer;